// extracted by mini-css-extract-plugin
export default {"chartWrapper":"MAInsightsDashboardChart_chartWrapper__Ykb9v"};